import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import ResourcesPage from './pages/resources';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import InspectionsPage from './pages/inspections';
import DashboardAppPage from './pages/home';
import ResourceDetailPage from './pages/resource-detail';
import InspectionDetailPage from './pages/inspection-detail';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'resources', element: <ResourcesPage /> },
        { path: 'resource-detail/:id', element: <ResourceDetailPage /> },
        { path: 'inspections', element: <InspectionsPage /> },
        { path: 'inspection-detail/:id', element: <InspectionDetailPage /> },
        { path: 'blog', element: <BlogPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
